import { useState } from 'react';
import styled from 'styled-components';
import { transNum } from '../../../func/func';
import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';
import Tags from '../../../func/Tags';

const EventModal = ({ setOpenModal }: any) => {
  const navigate = useNavigate();
  return (
    <Container>
      <Inner>
        <img
          src="/assets/images/modal/Modal.svg"
          alt=""
          style={{
            width: '100%',
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
          }}
          onClick={() => {
            navigate('/promotion/땅집고옥션-오픈기념-이벤트');
          }}
        />
        <Button_Box>
          <Close_Button
            onClick={() => {
              sessionStorage.setItem(
                'event_modal',
                `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
              );
              setOpenModal(false);
            }}
          >
            오늘 하루 보지 않기
          </Close_Button>
          <Close_Button
            onClick={() => {
              setOpenModal(false);
            }}
          >
            닫기
          </Close_Button>
        </Button_Box>
      </Inner>
    </Container>
  );
};

export default EventModal;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Inner = styled.div`
  width: 100%;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  display: flex;
  flex-direction: column;
  filter: blur(0);
  -webkit-filter: blur(0);
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
`;

const Button_Box = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
`;

const Close_Button = styled.button`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  height: 100%;
`;
